import style from "@styles/pages/oraculo/oraculo.module.scss";
import { Currency } from "@utils/Currency";

export default ({ totals }) => {
  const format_number = (n, p = 2) =>
    n.toLocaleString("pt-br", { maximumFractionDigits: p });

  return (
    <div className={style.totalsGrid}>
      <div className={style.total}>
        <p>
          {totals?.total_orders
            ? Currency.formatCurrency(totals?.total_orders)
            : "---"}
        </p>
        <span>Valor em vendas</span>
      </div>
      <div className={style.total}>
        <p>
          {totals?.delivery_total
            ? Currency.formatCurrency(totals?.delivery_total)
            : "---"}
        </p>
        <span>Valor em frete</span>
      </div>
      <div className={style.total}>
        <p>
          {totals?.count_orders ? format_number(totals?.count_orders) : "---"}
        </p>
        <span>Vendas realizadas</span>
      </div>
      <div className={style.total}>
        <p>
          {totals?.average_ticket
            ? Currency.formatCurrency(totals?.average_ticket)
            : "---"}
        </p>
        <span>Ticket médio</span>
      </div>
      <div className={style.total}>
        <p>
          {totals?.orders_per_client
            ? format_number(totals?.orders_per_client)
            : "---"}
        </p>
        <span>Pedidos por cliente</span>
      </div>
      <div className={style.total}>
        <p>
          {totals?.coupons_used ? format_number(totals?.coupons_used) : "---"}
        </p>
        <span>Usos de cupom</span>
      </div>
    </div>
  );
};
